// extracted by mini-css-extract-plugin
module.exports = {"list":"UserAvatarInlineList_list__2tKZx","listItem":"UserAvatarInlineList_listItem__2o8DY","userAvatar":"UserAvatarInlineList_userAvatar__1WPTi"};